/**
 * Configuration schema for Old Scheme Salary Breakup Matrix.
 * 
 * Follows Open/Closed Principle (OCP):
 * To add or modify sections or fields, update this declarative configuration
 * without changing the table or modal component rendering logic.
 */

export const FORMAT_TYPES = {
  CURRENCY: "currency",
  HOURS: "hours",
  NUMBER: "number",
  TEXT: "text",
};

export const SALARY_BREAKUP_SECTIONS = [
  {
    id: "particulars",
    title: "Particulars",
    badgeColor: "bg-blue-50 text-blue-800 border-blue-200",
    rows: [
      {
        id: "basic",
        label: "Basic",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.basic,
      },
      {
        id: "da",
        label: "DA",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.da,
      },
      {
        id: "basic_da",
        label: "Basic + DA",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => {
          if (item?.basic_da !== undefined && item?.basic_da !== null) {
            return item.basic_da;
          }
          const basic = Number(item?.basic) || 0;
          const da = Number(item?.da) || 0;
          return basic + da;
        },
      },
      {
        id: "hra",
        label: "HRA",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.hra,
      },
      {
        id: "ta",
        label: "TA",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.travel_allowance ?? item?.ta,
      },
      {
        id: "sa",
        label: "SA",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.supplementary_allowance ?? item?.sa,
      },
      {
        id: "wa",
        label: "WA",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.washing_allowance ?? item?.wa,
      },
      // {
      //   id: "stat_bonus",
      //   label: "Stat Bonus",
      //   formatType: FORMAT_TYPES.CURRENCY,
      //   accessor: (item) =>
      //     item?.stat_bonus ??
      //     item?.stat_bonus_monthly ??
      //     item?.statutory_bonus,
      // },
    ],
  },
  {
    id: "deduction",
    title: "Deduction",
    badgeColor: "bg-amber-50 text-amber-800 border-amber-200",
    rows: [
      {
        id: "epf",
        label: "Provident Fund (PF)",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.epf ?? item?.pf,
      },
      {
        id: "esic",
        label: "Employees' State Insurance (ESI)",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.esic ?? item?.esi,
      },
      {
        id: "employee_mlwf",
        label: "Employees' (MLWF)",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.employee_mlwf ?? item?.mlwf,
      },
      // {
      //   id: "stat_bonus_deduction",
      //   label: "Stat Bonus",
      //   formatType: FORMAT_TYPES.CURRENCY,
      //   accessor: (item) =>
      //     item?.stat_bonus ??
      //     item?.stat_bonus_monthly ??
      //     item?.statutory_bonus,
      // },
    ],
  },
  {
    id: "contributions",
    title: "Contributions",
    badgeColor: "bg-purple-50 text-purple-800 border-purple-200",
    rows: [
      {
        id: "employer_epf",
        label: "Provident Fund (PF)",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.employer_epf ?? item?.employer_pf,
      },
      {
        id: "employer_esic",
        label: "Employees' State Insurance (ESI)",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.employer_esic ?? item?.employer_esi,
      },
      {
        id: "employer_mlwf",
        label: "Employees' (MLWF)",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.employer_mlwf,
      },
      // {
      //   id: "stat_bonus_contributions",
      //   label: "Stat Bonus",
      //   formatType: FORMAT_TYPES.CURRENCY,
      //   accessor: (item) =>
      //     item?.stat_bonus ??
      //     item?.stat_bonus_monthly ??
      //     item?.statutory_bonus,
      // },
    ],
  },
  {
    id: "final",
    title: "Final",
    badgeColor: "bg-emerald-50 text-emerald-800 border-emerald-200",
    rows: [
      {
        id: "total_ot_hours",
        label: "OT hours",
        formatType: FORMAT_TYPES.HOURS,
        accessor: (item) => item?.total_ot_hours ?? item?.ot_hours,
      },
      {
        id: "holiday_hours",
        label: "Holiday Hours",
        formatType: FORMAT_TYPES.HOURS,
        accessor: (item) =>
          item?.total_holiday_ot_hours ??
          item?.holiday_hours ??
          item?.holiday_ot_hours,
      },
      {
        id: "late_hours",
        label: "Late Hours",
        formatType: FORMAT_TYPES.HOURS,
        accessor: (item) => item?.late_duration ?? item?.late_hours,
      },
      {
        id: "variable_ot_hours",
        label: "Variable OT hours",
        formatType: FORMAT_TYPES.HOURS,
        accessor: (item) =>
          item?.total_variable_ot_hours ?? item?.variable_ot_hours,
      },
      {
        id: "holiday_variable_ot_hours",
        label: "Holiday Variable OT Hours",
        formatType: FORMAT_TYPES.HOURS,
        accessor: (item) => item?.holiday_variable_ot_hours,
      },
      {
        id: "net_salary",
        label: "Net Salary Payable",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.net_salary ?? item?.net_salary_payable,
      },
      {
        id: "net_ot",
        label: "Net OT",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.net_ot,
      },
      {
        id: "net_payable",
        label: "Net Payable",
        formatType: FORMAT_TYPES.CURRENCY,
        accessor: (item) => item?.net_payable,
      },
    ],
  },
];
